import React, { useState, useEffect } from "react";
import {
  Input,
  Select,
  Form,
  Col,
  notification,
  Row,
  Button,
  Upload,
  Spin,
  Modal,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  PlusOutlined,
  MinusOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import config from "../../util/ApiforContext";
import FirmAccountAddForm from "./FirmAccountAddForm";
import RequestHandler from "../../util/RequestHandler";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};

const { TextArea } = Input;
const FirmAddForm = (props) => {
  const [form] = Form.useForm();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  const [IsHasSendFirmToLogo, setIsHasSendFirmToLogo] = useState(
    props.IsHasSendFirmToLogo
  );
  const [inputList, setInputList] = useState([{ word: "" }]);
  const [spinLoading, SetSpinLoading] = useState(false);
  const [wordList, setWordList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [firmTypeDropdown, setfirmTypeDropdown] = useState([]);
  const [transactionProjectTypes, setTransactionProjectTypes] = useState([]);
  const [firmClassDropdown, setfirmClassDropdown] = useState([]);
  const [FirmTypeValue, setFirmTypeValue] = useState(1);
  const [tckn, setTckn] = useState(props.Tckn);
  const [vkn, setVkn] = useState(props.Vkn);
  const [id, setId] = useState(props.Id);
  const [senderName, setSenderName] = useState(props.senderName);
  const [firmId, setFirmId] = useState("");
  const [iban, setIban] = useState(props.Iban);
  const [bankCode, setBankCode] = useState("");
  const [bankBranchName, setbankBranchName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [firmAccountVisible, setFirmAccountVisible] = useState(false);
  const errorList = [];

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { word: "" }]);
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const handleCancelFirmAccount = (e) => {
    openNotificationWithIcon("success");
    setLoading(false);
    if (props.GetTableData) {
      form.resetFields();
      props.GetTableData();
    } else window.location.reload();
    setFirmAccountVisible(false);
  };

  const onChangeFirmType = (value) => {
    setFirmTypeValue(value);
    RequestHandler.get(`/FirmClass?firmTypeId=${value}`).then((response) => {
      setfirmClassDropdown(response.value);
    });
  };

  useEffect(() => {
    setId(props.Id);
    setVkn(props.Vkn);
    setTckn(props.Tckn);
    setSenderName(props.SenderName);

    if (props.AccountId !== undefined) {
      RequestHandler.get(`/AccountTransaction/Getbyid/${props.Id}`).then(
        (response) => {
          setIban(response.iban);
          setAccountNumber(response.accountNumber);
          setbankBranchName(response.branchCode);
          setBankCode(response.otherBankCode);
        }
      );

      RequestHandler.get(`/AccountTransaction/GetBankCode/${props.Id}`).then(
        (response) => {
          setbankBranchName(response.message);
        }
      );
    }

    RequestHandler.get(`/FirmClass?firmTypeId=1`).then((response) => {
      setfirmClassDropdown(response.value);
    });

    RequestHandler.get(`/Firm/GetFirmType`).then((response) => {
      setfirmTypeDropdown(response.data);
    });

    RequestHandler.get(
      `/TransactionProjectType?$filter= ProjectType eq 4`
    ).then((response) => {
      setTransactionProjectTypes(response.value);
    });

    setFirmTypeValue(1);
  }, [
    setfirmTypeDropdown,
    setTransactionProjectTypes,
    setfirmClassDropdown,
    setFirmTypeValue,
    setTckn,
    setVkn,
    setSenderName,
    props.SenderName,
    props.Vkn,
    props.Tckn,
  ]);

  const { Option } = Select;
  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Ekleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };
  const errorListNotification = (type) => {
    errorList.map((item) => {
      notification[type]({
        message: "Hata",
        description: item,
        duration: 5,
      });
    });
  };
  const onChangeVknValue = (e) => {
    setVkn(e.target.value);
  };
  const onChangeTcNoValue = (e) => {
    setTckn(e.target.value);
  };
  const onChangeSenderNameValue = (e) => {
    setSenderName(e.target.value);
  };

  const onFinish = (values) => {
    const words = [];
    inputList.map((item) => {
      words.push(item.word.trim());
    });
    var error = 0;
    words.map((item) => {
      var wordLength = item.length;
      if (wordLength < 5 && wordLength != 0) {
        error += 1;
      }
    });

    RequestHandler.post(
      `/Firm`,
      {
        tenantId: localStorage.getItem("tenantId"),
        name: values.Name,
        firmBranchNumber: values.FirmBranchNumber,
        tcNo: values.TcNo,
        erpSalesCode: values.ErpSalesCode,
        customerType: values.CustomerType,
        placeType: values.PlaceType,
        purchaseType: values.PurchaseType,
        erpCode: values.ErpCode,
        directiveName: values.DirectiveName,
        email: values.Email,
        taxOffice: values.TaxOffice,
        vkn: values.Vkn,
        phone: values.Phone,
        mobilePhone: values.MobilePhone,
        fax: values.Fax,
        address: values.Address,
        groupCode: values.GroupCode,
        city: values.City,
        town: values.Town,
        specialCode: values.SpecialCode,
        authorizationCode: values.AuthorizationCode,
        accountCode: values.AccountCode,
        accountTransactionId:
          props.AccountId === undefined
            ? "00000000-0000-0000-0000-000000000000"
            : props.AccountId,
        firmTypeValue: values.FirmTypeValue,
        firmClassId: values.FirmClassId,
        accountingCode: values.accountingCode,
        transactionProjectTypeId: values.TransactionProjectTypeId,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        if (error == 0) {
          RequestHandler.post(
            `/Firm/FirmMatchingWordAdd`,
            {
              firmId: res.data.data.id,
              words: words,
            },
            false,
            { rawResponse: true }
          ).then((res) => {
            if (res.status == 200) {
              openNotificationWithIcon("success");
              if (props.AccountId === undefined) {
                if (props.GetTableData) {
                  form.resetFields();
                  props.GetTableData();
                } else
                  setTimeout(
                    function () {
                      window.location.reload();
                    }.bind(this),
                    2000
                  );
              }
            } else {
              setLoading(false);
              SetSpinLoading(false);
            }
          });

          if (props.AccountId !== undefined) {
            if (props.getTableDate) props.getTableDate();
            else {
              setFirmAccountVisible(true);
              setFirmId(res.data.data.id);
            }
            //  setTimeout(
            //    function () {
            //      window.location.reload();
            //    }.bind(this),
            //    2000
            //  );
          }
        } else {
          openNotificationWithIcon("success");
          wordLengtError("error");
          setLoading(false);
          setTimeout(
            function () {
              window.location.reload();
            }.bind(this),
            3500
          );
        }
        setWordList(words);
      } else {
        setLoading(false);
        SetSpinLoading(false);
      }
    });
  };

  const excelDownload = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Excel şablonu indirme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const wordLengtError = (type) => {
    notification[type]({
      message: "HATA",
      description:
        "Kelimeler bölümündeki harf sayısı 5ten küçük olduğu için kayıt başarısız oldu, düzenleyip tekrar deneyin.",
      duration: 4,
    });
  };

  const excelDownloadFailedUntilThis = (type) => {
    notification[type]({
      message: "HATA",
      description: "Bu veriden sonra yüklemeye devam edilemedi.",
      duration: 5,
    });
  };

  const downloadExcel = () => {
    window.open(
      `${config.apiUrl}/Firm/DownloadExcel?t=${RequestHandler.getToken()}`
    );
  };
  const propsFirmExcel = {
    name: "excel",
    action: `${config.apiUrl}/Firm/ImportExcel?type=1`,
    headers: { Authorization: "bearer " + RequestHandler.getToken() },
    beforeUpload() {
      setTimeout(function () {
        notification.info({
          message: "Uyarı",
          description:
            "Bu işlem bir kaç dakika sürebilir, tüm veri uygunluğu kontrol edilerek hatalı veri varsa otomatik Excel inecektir. Lütfen bekleyiniz..",
          duration: 5,
        });
      }, 3000);
    },
    onChange(info) {
      const { response, status } = info.file;
      if (info.fileList.length > 0) {
        SetSpinLoading(true);
        document.body.querySelector(".ant-drawer-body").scrollTo(0, 0);
      }
      if (info.file.status === "done") {
        excelDownload("success");
        setTimeout(
          function () {
            window.location.reload();
          }.bind(this),
          2000
        );
      } else if (info.file.status === "error") {
        if (info.file.response.statusCode === 406) {
          info.file.response.data.map((item) => {
            errorList.push(item);
            setTimeout(function () {
              window.location.reload();
            }, 5000);
          });
          errorListNotification("error");
          excelDownloadFailedUntilThis("error");
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        } else {
          const notificationType = response.success ? "success" : "error";

          notification[notificationType]({
            message: response.message,
            duration: 3,
          });
          if (!response.success) {
            downloadImportResult(info.file.response.data);
          }
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        }

        SetSpinLoading(false);
      }
    },
  };
  const downloadImportResult = (fileName) => {
    window.open(
      `${
        config.apiUrl
      }/Firm/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}`
    );
  };

  const onFinishFailed = () => setLoading(false);
  const ScreenNameWithActiveTab = () => {
    switch (props.activeTab) {
      case "1":
        return "Bayi";
      case "2":
        return "Banka";
      case "3":
        return "Masraf";
      case "4":
        return "Çek";
      case "5":
        return "Senet";
    }
  };
  return (
    <div>
      <Spin tip="Excel yükleniyor..." spinning={spinLoading}>
        <Form
          form={form}
          {...layout}
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          fields={[
            { name: "FirmTypeValue", value: FirmTypeValue.toString() },
            {
              name: "Vkn",
              value: vkn?.toString() === "" ? null : vkn?.toString(),
            },
            { name: "TcNo", value: tckn === "" ? null : tckn },
            { name: "Name", value: senderName === "" ? null : senderName },
          ]}
        >
          <Row>
            {isDesktopOrLaptop && (
              <>
                <Col span={20}>
                  <Form.Item
                    onChange={onChangeSenderNameValue}
                    style={{ marginTop: "4%" }}
                    label={`${ScreenNameWithActiveTab("1")} Adı${
                      props.activeTab == "1" ? "/Ünvanı" : ""
                    }`}
                    name="Name"
                    rules={[
                      {
                        required: true,
                        message:
                          "Lütfen Bayi Adı/Ünvanı alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  {/* <Form.Item label="Talimat Ünvanı" name="DirectiveName">
                    <Input />
                  </Form.Item> */}
                  <Form.Item label="E-Posta Adresi" name="Email">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Vergi Dairesi" name="TaxOffice">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Vergi Numarası" name="Vkn">
                    <Input
                      onChange={onChangeVknValue}
                      type="number"
                      onKeyDown={(evt) =>
                        evt.key === "e" && evt.preventDefault()
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    label="T.C. Kimlik No "
                    name="TcNo"
                    rules={[
                      {
                        min: 11,
                        message: "TcNo 11 karakter olmalıdır.",
                      },
                    ]}
                  >
                    <Input
                      onChange={onChangeTcNoValue}
                      type="number"
                      onKeyDown={(evt) =>
                        evt.key === "e" && evt.preventDefault()
                      }
                      maxLength="11"
                      onInput={maxLengthCheck}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Telefon Numarası"
                    name="Phone"
                    rules={[
                      {
                        min: 12,
                        message: "Telefon numarasını eksiksiz giriniz.",
                      },
                    ]}
                  >
                    <PhoneInput
                      inputStyle={{ width: "100%" }}
                      country="tr"
                      masks={{ tr: "(...) ...-..-.." }}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Cep Numarası"
                    name="MobilePhone"
                    rules={[
                      {
                        min: 12,
                        message: "Telefon numarasını eksiksiz giriniz.",
                      },
                    ]}
                  >
                    <PhoneInput
                      inputStyle={{ width: "100%" }}
                      country="tr"
                      masks={{ tr: "(...) ...-..-.." }}
                    />
                  </Form.Item>
                  {/* <Form.Item label="Fax Numarası" name="Fax">
                    <Input />
                  </Form.Item> */}
                  <Form.Item label="Adres" name="Address">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Form.Item label="Bayi Tipi" name="FirmTypeValue">
                    <Select
                      placeholder="Seçiniz"
                      optionFilterProp="children"
                      onChange={onChangeFirmType}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {firmTypeDropdown.map((item) => (
                        <Option key={item.key}>{item.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label={`Bayi Kodu`}
                    name="FirmBranchNumber"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen Bayi Kodu alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item label="İl" name="City">
                    <Input />
                  </Form.Item>
                  <Form.Item label="İlçe" name="Town">
                    <Input />
                  </Form.Item>
                  {/* <Form.Item label="Özel Kod" name="SpecialCode">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Yetki Kodu" name="AuthorizationCode"
                    rules={[
                      {
                        required: IsHasSendFirmToLogo,
                        message: "Lütfen Yetki Kodu alanını boş bırakmayın.",
                      },
                    ]}>
                    <Input />
                  </Form.Item>
                  <Form.Item label="Hesap Kodu" name="AccountCode">
                    <Input />
                  </Form.Item> */}
                  <Form.Item label="Satıcı Kodu" name="ErpSalesCode">
                    <Input />
                  </Form.Item>
                  {/* <Form.Item label="Bayi Sınıfı" name="FirmClassId">
                    <Select
                      showSearch
                      placeholder="Seçiniz"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {firmClassDropdown.map((item) => (
                        <Option key={item.id}>{item.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {IsHasSendFirmToLogo &&
                    <Form.Item name="PlaceType" label="İşyeri"
                      rules={[
                        {
                          required: true,
                          message: "Lütfen İşyeri alanını boş bırakmayın.",
                        },
                      ]}>
                      <Select placeholder="Seçiniz">
                        <Select.Option key={'T'} value={'T'}>
                          Tarsus
                        </Select.Option>
                        <Select.Option key={'M'} value={'M'}>
                          Mersin
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  }
                  {IsHasSendFirmToLogo &&
                    <Form.Item name="PurchaseType" label="Alım Türü"
                      rules={[
                        {
                          required: true,
                          message: "Lütfen Alım Türü alanını boş bırakmayın.",
                        },
                      ]}>
                      <Select placeholder="Seçiniz">
                        <Select.Option key={'01'} value={'01'}>
                          Sıfır
                        </Select.Option>
                        <Select.Option key={'03'} value={'03'}>
                          Servis
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  }
                  {IsHasSendFirmToLogo &&
                    <Form.Item name="CustomerType" label="Müşteri Türü"
                      rules={[
                        {
                          required: true,
                          message: "Lütfen Müşteri Türü alanını boş bırakmayın.",
                        },
                      ]}>
                      <Select placeholder="Seçiniz">
                        <Select.Option key={'120'} value={'120'}>
                          Müşteri
                        </Select.Option>
                        <Select.Option key={'320'} value={'320'}>
                          Satıcı
                        </Select.Option>
                        <Select.Option key={'340'} value={'340'}>
                          Kapora
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  } */}
                  {/* <Form.Item label="Grup Kodu" name="GroupCode">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Muhasebe Kodu" name="accountingCode">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Kelimeler" name="words">
                    {inputList.map((x, i) => {
                      return (
                        <Row>
                          <Col span={20} style={{ marginLeft: "-6%" }}>
                            <Input
                              name="word"
                              placeholder="Kelime Girin"
                              value={x.word}
                              onChange={(e) => handleInputChange(e, i)}
                            />
                          </Col>
                          <Col span={2}>
                            {inputList.length !== 1 && (
                              <Button
                                className="mr10"
                                onClick={() => handleRemoveClick(i)}
                              >
                                <MinusOutlined />
                              </Button>
                            )}
                            {inputList.length - 1 === i && (
                              <Button onClick={handleAddClick}>
                                <PlusOutlined />
                              </Button>
                            )}
                          </Col>
                        </Row>
                      );
                    })}
                  </Form.Item> */}
                </Col>
                <Col span={4}></Col>
                <Col span={6} style={{ marginLeft: -5 }}>
                  <Upload {...propsFirmExcel}>
                    <Button icon={<UploadOutlined />}>
                      Excel ile Bayi Ekle
                    </Button>
                  </Upload>
                </Col>
                <Col span={6}>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={(() => setLoading(true), downloadExcel)}
                    loading={loading}
                  >
                    Excel Şablonu İndir
                  </Button>
                </Col>
                <Col span={6}></Col>
                <Col span={6}>
                  <Form.Item {...tailLayout}>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      htmlType="submit"
                      onClick={() => setLoading(true)}
                      loading={loading}
                    >
                      Ekle
                    </Button>
                  </Form.Item>
                </Col>
              </>
            )}
            {isTabletOrMobileDevice && (
              <>
                <Col span={24}>
                  <Form.Item
                    onChange={onChangeSenderNameValue}
                    style={{ marginTop: "4%" }}
                    label="Bayi Adı/Ünvanı"
                    name="Name"
                    rules={[
                      {
                        required: true,
                        message:
                          "Lütfen Bayi Adı/Ünvanı alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  {/* <Form.Item label="Talimat Ünvanı" name="DirectiveName">
                    <Input />
                  </Form.Item> */}
                  <Form.Item label="E-Posta Adresi" name="Email">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Vergi Dairesi" name="TaxOffice">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Vergi Numarası" name="Vkn">
                    <Input
                      onChange={onChangeVknValue}
                      type="number"
                      onKeyDown={(evt) =>
                        evt.key === "e" && evt.preventDefault()
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    label="T.C. Kimlik No "
                    name="TcNo"
                    rules={[
                      {
                        min: 11,
                        message: "TcNo 11 karakter olmalıdır.",
                      },
                    ]}
                  >
                    <Input
                      onChange={onChangeTcNoValue}
                      type="number"
                      onKeyDown={(evt) =>
                        evt.key === "e" && evt.preventDefault()
                      }
                      maxLength="11"
                      onInput={maxLengthCheck}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Telefon Numarası"
                    name="Phone"
                    rules={[
                      {
                        min: 12,
                        message: "Telefon numarasını eksiksiz giriniz.",
                      },
                    ]}
                  >
                    <PhoneInput
                      inputStyle={{ width: "100%" }}
                      country="tr"
                      masks={{ tr: "(...) ...-..-.." }}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Cep Numarası"
                    name="MobilePhone"
                    rules={[
                      {
                        min: 12,
                        message: "Telefon numarasını eksiksiz giriniz.",
                      },
                    ]}
                  >
                    <PhoneInput
                      inputStyle={{ width: "100%" }}
                      country="tr"
                      masks={{ tr: "(...) ...-..-.." }}
                    />
                  </Form.Item>
                  {/* <Form.Item label="Fax Numarası" name="Fax">
                    <Input />
                  </Form.Item> */}
                  <Form.Item label="Adres" name="Address">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Form.Item label="Bayi Tipi" name="FirmTypeValue">
                    <Select
                      placeholder="Seçiniz"
                      optionFilterProp="children"
                      onChange={onChangeFirmType}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {firmTypeDropdown.map((item) => (
                        <Option key={item.key}>{item.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Bayi Kodu"
                    name="FirmBranchNumber"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen Bayi Kodu alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  {/* <Form.Item
                    label="Erp Kodu"
                    name="ErpCode"
                    rules={[
                      {
                        max: 100,
                        message:
                          "Erp Kodu alanı maksimum 100 karakter olmalıdır.",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item> */}
                  <Form.Item label="İl" name="City">
                    <Input />
                  </Form.Item>
                  <Form.Item label="İlçe" name="Town">
                    <Input />
                  </Form.Item>
                  {/* <Form.Item label="Özel Kod" name="SpecialCode">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Yetki Kodu" name="AuthorizationCode"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item label="Hesap Kodu" name="AccountCode">
                    <Input />
                  </Form.Item> */}
                  {/* <Form.Item label="Bayi Sınıfı" name="FirmClassId">
                    <Select
                      showSearch
                      placeholder="Seçiniz"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {firmClassDropdown.map((item) => (
                        <Option key={item.id}>{item.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item label="Grup Kodu" name="GroupCode">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Kelimeler" name="words">
                    {inputList.map((x, i) => {
                      return (
                        <Row>
                          <Col span={20} style={{ marginLeft: "-6%" }}>
                            <Input
                              name="word"
                              placeholder="Kelime Girin"
                              value={x.word}
                              onChange={(e) => handleInputChange(e, i)}
                            />
                          </Col>
                          <Col span={2}>
                            {inputList.length !== 1 && (
                              <Button
                                className="mr10"
                                onClick={() => handleRemoveClick(i)}
                              >
                                <MinusOutlined />
                              </Button>
                            )}
                            {inputList.length - 1 === i && (
                              <Button onClick={handleAddClick}>
                                <PlusOutlined />
                              </Button>
                            )}
                          </Col>
                        </Row>
                      );
                    })}
                  </Form.Item> */}
                </Col>

                <Col span={12}></Col>
                <Col span={6}>
                  <Form.Item {...tailLayout}>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      htmlType="submit"
                      onClick={() => setLoading(true)}
                      loading={loading}
                    >
                      Ekle
                    </Button>
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
                <Col span={24}>
                  <Upload {...propsFirmExcel}>
                    <Button icon={<UploadOutlined />}>
                      Excel ile Bayi Ekle
                    </Button>
                  </Upload>
                </Col>
                <Col span={24}>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={(() => setLoading(true), downloadExcel)}
                    loading={loading}
                  >
                    Excel Şablonu İndir
                  </Button>
                </Col>
              </>
            )}
          </Row>
        </Form>
      </Spin>
      <Modal
        title="Firma Hesabı Ekle"
        visible={firmAccountVisible}
        onCancel={handleCancelFirmAccount}
        closable={true}
        footer={[]}
      >
        <FirmAccountAddForm
          data={{ firmId: firmId, iban: iban, accountNumber: accountNumber }}
          onSuccess={handleCancelFirmAccount}
        />
      </Modal>
    </div>
  );
};
export default FirmAddForm;
